import { render, staticRenderFns } from "./IdentityOCR.vue?vue&type=template&id=5f6bc6ad&scoped=true"
import script from "./IdentityOCR.vue?vue&type=script&lang=js"
export * from "./IdentityOCR.vue?vue&type=script&lang=js"
import style0 from "./IdentityOCR.vue?vue&type=style&index=0&id=5f6bc6ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6bc6ad",
  null
  
)

export default component.exports